import { ResponsiveSunburst } from '@nivo/sunburst';
import i18n from '@/i18n/config';

const sunburstData = {
  name: i18n.t('copy.project_alpha'),
  color: 'hsl(13, 70%, 50%)',
  children: [
    {
      name: i18n.t('copy.feature_a'),
      color: 'hsl(106, 70%, 50%)',
      children: [
        { name: i18n.t('experimentStatus.completed.label'), value: 10 },
        { name: i18n.t('copy.in_progress'), value: 5 }
      ]
    },
    {
      name: i18n.t('copy.feature_b'),
      color: 'hsl(171, 70%, 50%)',
      children: [
        { name: i18n.t('copy.finished'), value: 8 },
        { name: i18n.t('experimentStatus.active.label'), value: 2 },
        { name: i18n.t('copy.to_do'), value: 4 }
      ]
    },
    {
      name: i18n.t('copy.bug_fixes'),
      color: 'hsl(215, 70%, 50%)',
      children: [
        { name: i18n.t('copy.resolved'), value: 15 },
        { name: i18n.t('enums.pending'), value: 3 }
      ]
    }
  ]
};

export const TaskDistributionChart = () => (
  <div style={{ height: '400px' }}>
    <ResponsiveSunburst
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 1.4]] }}
      borderColor="white"
      borderWidth={1}
      childColor={{ from: 'color', modifiers: [['brighter', 0.1]] }}
      colors={{ scheme: 'nivo' }}
      cornerRadius={2}
      data={sunburstData}
      enableArcLabels={true}
      id="name"
      margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
      value="value"
    />
  </div>
);
